export default "__VITE_PUBLIC_ASSET__0c27df5d__"